function syncAgentPropertiesToCartAttributes() {
  var cartUrl = (window.routes && window.routes.cartUrl) || "/cart";
  return fetch(cartUrl + ".js", { credentials: "same-origin" })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var items = cart.items || [];
      var agentName = null;
      var agentEmail = null;
      for (var i = 0; i < items.length; i++) {
        var props = items[i].properties;
        if (!props) {
          continue;
        }
        var n = props["_agent_name"];
        var em = props["_agent_email"];
        var hasName = n != null && String(n).trim() !== "";
        var hasEmail = em != null && String(em).trim() !== "";
        if (!hasName && !hasEmail) {
          continue;
        }
        if (hasName) {
          agentName = String(n);
        }
        if (hasEmail) {
          agentEmail = String(em);
        }
        break;
      }
      if (agentName === null && agentEmail === null) {
        return null;
      }
      var attributes = Object.assign({}, cart.attributes || {});
      if (agentName !== null) {
        attributes["agent"] = agentName;
      }
      if (agentEmail !== null) {
        attributes["agent_email"] = agentEmail;
      }
      return fetch(cartUrl + "/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ attributes: attributes }),
      });
    });
}

document.addEventListener("product:added", function () {
  syncAgentPropertiesToCartAttributes().catch(function () {});
});

document.addEventListener(
  "submit",
  function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") {
      return;
    }
    var action = form.getAttribute("action") || "";
    if (action.indexOf("/cart/add") === -1) {
      return;
    }
    if (
      !form.querySelector(
        '[name="properties[_agent_name]"], [name="properties[_agent_email]"]'
      )
    ) {
      return;
    }
    if (!window.theme || window.theme.cartType !== "page") {
      return;
    }
    if (typeof Form === "undefined" || !Form.serialize) {
      return;
    }
    if (typeof form.reportValidity === "function" && !form.reportValidity()) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
    }
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    fetch(window.routes.cartAddUrl + ".js", {
      body: JSON.stringify(Form.serialize(form)),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        if (!response.ok) {
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
          }
          return;
        }
        return syncAgentPropertiesToCartAttributes().then(function () {
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
          }
          window.location.href = window.routes.cartUrl;
        });
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        if (submitBtn) {
          submitBtn.removeAttribute("disabled");
        }
      });
  },
  true
);

$(document).ready(function () {

  /*** Video Toggle for Installation Video ***/
  $("button.video-toggle-button").on("click", function () {
      var $parent = $(this).closest(".col-md-4.cstm-installation-video");
      $parent.find(".youtube-video-section").show();
      $parent.find(".overlay-video-yt").hide();
      $parent.find(".youtube-video-section video").get(0).play();
  });

  /*** Product Video & Text Section ***/
  $("button.ov-btn").on("click", function () {
      var $parent = $(this).closest('.video-section-in-rght');
      $parent.find(".overlay-banner-v").hide();
      $parent.find(".video-container-v-t").show();
      $parent.find(".video-container-v-t video").get(0).play();
  });

  /*** Video & Text Section (Delegated Event) ***/
  $(document).on("click", '.v-t-items button.ov-button', function () {
      var $parent = $(this).closest('.v-t-item');
      $parent.find('.v-t-img .overlay-banner-v').hide();
      $parent.find('.v-t-img .video-container-v-t').show();
      $parent.find('.v-t-img .video-container-v-t video').get(0).play();
  });

  /*** Wrap Installation Section Videos ***/
  $(".installation-section .col-md-4.cstm-installation-video").wrapAll("<div class='video-installation'/>");

});

/*** Circle Play Button for Video ***/
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("video");
  const circlePlayButton = document.getElementById("circle-play-b");

  function togglePlay() {
      if (video.paused || video.ended) {
          video.play();
      } else {
          video.pause();
      }
  }

  if (circlePlayButton) {
      circlePlayButton.addEventListener("click", togglePlay);
  }

  if (video) {
      video.addEventListener("playing", function () {
          circlePlayButton.style.opacity = 0;
      });

      video.addEventListener("pause", function () {
          circlePlayButton.style.opacity = 1;
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".collection-page-menu");

  triggers.forEach((trigger, index) => {
    const isEven = (index + 1) % 2 === 0;
    const hoverClass = isEven ? "hover-even" : "hover-odd";

    trigger.addEventListener("mouseenter", function () {
      this.classList.add("onhoverclicked", hoverClass);
    });

    trigger.addEventListener("mouseleave", function () {
      this.classList.remove("onhoverclicked", "hover-even", "hover-odd");
    });
  });
});